'use client';

import React from 'react';
import { IconButton, Tooltip } from '@mui/material';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import { isPlatformExplore, isPlatformHub } from '@/constants/common';
import { useAgentContext } from '../../context/AgentContext';
import { useAiAssistantEnabled } from '../../hooks/useAiAssistantEnabled';

export default function AgentPanelToggle() {
  const flagEnabled = useAiAssistantEnabled();

  const isEnabled =
    (isPlatformHub || isPlatformExplore) && process.env.NEXT_PUBLIC_AGENT_WS_URL && flagEnabled;

  const { state, togglePanel } = useAgentContext();

  if (!isEnabled) return null;

  return (
    <Tooltip title="SkyWatch Enterprise Assistant">
      <IconButton
        onClick={togglePanel}
        sx={{
          color: state.panelOpen ? 'var(--primary-color)' : 'var(--sw-white-color)',
          '&:hover': {
            color: 'var(--primary-color)',
            bgcolor: 'transparent',
          },
        }}
      >
        <AutoAwesomeIcon />
      </IconButton>
    </Tooltip>
  );
}
